// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.custom-footer {
    color: #fff;
    font-family: "Noto Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
    width: 100%;
    background: transparent;
    padding: 3rem 2rem 1rem;
    box-sizing: border-box;
    max-width: 1440px;
    margin: 7rem auto 3rem auto;
    width: 100%;
    padding-left: 4rem;
    @media (max-width: 480px) {
        margin: 4rem auto 2rem auto;
        padding-left:2.5rem;
      }
  }
  
  .footer-container {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: center;
    border-bottom: 1.5px solid #949495;
    padding-bottom: 1rem;
  }
  
  .footer-column {
    width: 22%;
    margin: 0;
  }
  
  .footer-logo {
    max-width: 100%;
    margin-top: 0;
    height: auto; 
  }
  
  /* Section Titles */
  .footer-column h3 {
    color: #70f0a3 !important;
    font-size: 18px;
    font-weight: 600;
    margin: 0 0 0.8rem 0;
  }
  
  /* Links */
  .footer-column ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
  }
  
  .footer-column li {
    margin: 10px 0;
  }
  
  .footer-column a {
    color: #fff;
    text-decoration: none;
    font-size: 16px;
    transition: color 0.3s ease-in-out;
  }
  
  .footer-column a:hover {
    color: #02afc8;
  }
  
  /* Social Icons */
  .footer-column.social-column ul {
    display: flex;
    list-style-type: none;
    padding: 0;
    margin: 0;
    justify-content: start;
  }
  
  .footer-column.social-column li {
    margin-right: 20px;
  }
  
  .social-icon {
    width: 40px;
    height: 40px;
    transition: transform 0.3s ease-in-out;
  }
  
  .social-icon:hover {
    transform: scale(1.1);
  }
  
  /* Footer Bottom */
  .footer-bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
    font-size: 14px;
    color: #ccc;
  }
  
  /* ============================= */
  /*          Responsive           */
  /* ============================= */
  @media (max-width: 768px) {
    .footer-container {
      /* flex-wrap: wrap; */
      justify-content: space-between;
      text-align: center;
    }
    .footer-logo{
        max-width: 100%;
    }
  
    .footer-column {
      width: 100%;
      margin-bottom: 1rem;
    }
  
    .footer-column.platform-column,
    .footer-column.about-column {
      width: 48%;
      padding: 10px 1%;
      text-align: start;
      box-sizing: border-box;
    }
  
    .footer-column.social-column ul {
      justify-content: center;
    }
  
    .footer-bottom {
      flex-direction: column;
      justify-content: center;
      text-align: center;
    }
  }
  
  @media (max-width: 480px) {
    .social-icon {
      width: 30px;
      height: 30px;
    }
  
  
    .footer-bottom {
      font-size: 12px;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/assets/styles/Footer.css"],"names":[],"mappings":";AACA;IACI,WAAW;IACX,2FAA2F;IAC3F,WAAW;IACX,uBAAuB;IACvB,uBAAuB;IACvB,sBAAsB;IACtB,iBAAiB;IACjB,2BAA2B;IAC3B,WAAW;IACX,kBAAkB;IAClB;QACI,2BAA2B;QAC3B,mBAAmB;MACrB;EACJ;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,mBAAmB;IACnB,kCAAkC;IAClC,oBAAoB;EACtB;;EAEA;IACE,UAAU;IACV,SAAS;EACX;;EAEA;IACE,eAAe;IACf,aAAa;IACb,YAAY;EACd;;EAEA,mBAAmB;EACnB;IACE,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA,UAAU;EACV;IACE,qBAAqB;IACrB,UAAU;IACV,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,kCAAkC;EACpC;;EAEA;IACE,cAAc;EAChB;;EAEA,iBAAiB;EACjB;IACE,aAAa;IACb,qBAAqB;IACrB,UAAU;IACV,SAAS;IACT,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,sCAAsC;EACxC;;EAEA;IACE,qBAAqB;EACvB;;EAEA,kBAAkB;EAClB;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,WAAW;EACb;;EAEA,kCAAkC;EAClC,kCAAkC;EAClC,kCAAkC;EAClC;IACE;MACE,qBAAqB;MACrB,8BAA8B;MAC9B,kBAAkB;IACpB;IACA;QACI,eAAe;IACnB;;IAEA;MACE,WAAW;MACX,mBAAmB;IACrB;;IAEA;;MAEE,UAAU;MACV,gBAAgB;MAChB,iBAAiB;MACjB,sBAAsB;IACxB;;IAEA;MACE,uBAAuB;IACzB;;IAEA;MACE,sBAAsB;MACtB,uBAAuB;MACvB,kBAAkB;IACpB;EACF;;EAEA;IACE;MACE,WAAW;MACX,YAAY;IACd;;;IAGA;MACE,eAAe;IACjB;EACF","sourcesContent":["\n.custom-footer {\n    color: #fff;\n    font-family: \"Noto Sans\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n    width: 100%;\n    background: transparent;\n    padding: 3rem 2rem 1rem;\n    box-sizing: border-box;\n    max-width: 1440px;\n    margin: 7rem auto 3rem auto;\n    width: 100%;\n    padding-left: 4rem;\n    @media (max-width: 480px) {\n        margin: 4rem auto 2rem auto;\n        padding-left:2.5rem;\n      }\n  }\n  \n  .footer-container {\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    align-items: center;\n    border-bottom: 1.5px solid #949495;\n    padding-bottom: 1rem;\n  }\n  \n  .footer-column {\n    width: 22%;\n    margin: 0;\n  }\n  \n  .footer-logo {\n    max-width: 100%;\n    margin-top: 0;\n    height: auto; \n  }\n  \n  /* Section Titles */\n  .footer-column h3 {\n    color: #70f0a3 !important;\n    font-size: 18px;\n    font-weight: 600;\n    margin: 0 0 0.8rem 0;\n  }\n  \n  /* Links */\n  .footer-column ul {\n    list-style-type: none;\n    padding: 0;\n    margin: 0;\n  }\n  \n  .footer-column li {\n    margin: 10px 0;\n  }\n  \n  .footer-column a {\n    color: #fff;\n    text-decoration: none;\n    font-size: 16px;\n    transition: color 0.3s ease-in-out;\n  }\n  \n  .footer-column a:hover {\n    color: #02afc8;\n  }\n  \n  /* Social Icons */\n  .footer-column.social-column ul {\n    display: flex;\n    list-style-type: none;\n    padding: 0;\n    margin: 0;\n    justify-content: start;\n  }\n  \n  .footer-column.social-column li {\n    margin-right: 20px;\n  }\n  \n  .social-icon {\n    width: 40px;\n    height: 40px;\n    transition: transform 0.3s ease-in-out;\n  }\n  \n  .social-icon:hover {\n    transform: scale(1.1);\n  }\n  \n  /* Footer Bottom */\n  .footer-bottom {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 10px;\n    font-size: 14px;\n    color: #ccc;\n  }\n  \n  /* ============================= */\n  /*          Responsive           */\n  /* ============================= */\n  @media (max-width: 768px) {\n    .footer-container {\n      /* flex-wrap: wrap; */\n      justify-content: space-between;\n      text-align: center;\n    }\n    .footer-logo{\n        max-width: 100%;\n    }\n  \n    .footer-column {\n      width: 100%;\n      margin-bottom: 1rem;\n    }\n  \n    .footer-column.platform-column,\n    .footer-column.about-column {\n      width: 48%;\n      padding: 10px 1%;\n      text-align: start;\n      box-sizing: border-box;\n    }\n  \n    .footer-column.social-column ul {\n      justify-content: center;\n    }\n  \n    .footer-bottom {\n      flex-direction: column;\n      justify-content: center;\n      text-align: center;\n    }\n  }\n  \n  @media (max-width: 480px) {\n    .social-icon {\n      width: 30px;\n      height: 30px;\n    }\n  \n  \n    .footer-bottom {\n      font-size: 12px;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
